<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>联系方式配置</span>
                </div>
                <div class="title_desc">按国家/地区独立配置联系方式。H5 页面根据用户所在国家自动匹配，未匹配到时使用「默认兜底」国家的配置。</div>
            </div>

            <div class="btn_box">
                <div class="btn_right_box">
                    <div class="button button2 add" @click="openCreate" v-if="roleCheck('103-104-103-102')">
                        <i class="el-icon-plus"></i>
                        <span>新增联系方式</span>
                    </div>
                </div>
            </div>

            <div class="contact_grid" v-loading="loading">
                <div v-for="item in contactList" :key="item.id" class="contact_card">
                    <div class="card_head">
                        <span class="country_name">{{ item.country }}</span>
                        <span v-if="item.is_default" class="default_tag">默认兜底</span>
                    </div>
                    <div class="card_row">
                        <label>电话</label>
                        <span>{{ item.phone || '-' }}</span>
                    </div>
                    <div class="card_row">
                        <label>邮箱</label>
                        <span>{{ item.email || '-' }}</span>
                    </div>
                    <div class="card_row">
                        <label>服务时间</label>
                        <span>{{ item.service_time || '-' }}</span>
                    </div>
                    <div class="card_actions">
                        <div class="button text" @click="openEdit(item)" v-if="roleCheck('103-104-103-102')">编辑</div>
                        <div class="button text del_btn" @click="delItem(item)" v-if="roleCheck('103-104-103-102')">删除</div>
                    </div>
                </div>
                <div v-if="!loading && contactList.length === 0" class="empty_hint">暂无配置，点击「新增联系方式」开始配置</div>
            </div>

            <Tip ref="tip" :msg="delMsg" @tipBack="delConfirm"></Tip>

            <!-- 新增/编辑弹窗 -->
            <Gh-Dialog size="big" ref="editDialog" :title="dialogMode === 'create' ? '新增联系方式' : '编辑联系方式'" @dialogBack="confirmSubmit">
                <template v-slot:cancel_btn>
                    <span></span>
                </template>
                <template v-slot:content>
                    <el-form label-width="110px" :model="editForm" style="max-width: 480px;">
                        <el-form-item label="国家/地区" required>
                            <el-input v-model="editForm.country" placeholder="请输入国家/地区代码，如 US / DE / JP" :disabled="dialogMode === 'edit'" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input v-model="editForm.phone" placeholder="请输入客服电话" maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱">
                            <el-input v-model="editForm.email" placeholder="请输入客服邮箱" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item label="服务时间">
                            <el-input v-model="editForm.serviceTime" placeholder="例如：周一至周五 09:00-18:00" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item label="默认兜底">
                            <el-switch v-model="editForm.isDefault"></el-switch>
                            <span class="form_tip">开启后，未匹配到国家的用户将展示此配置（旧的默认配置会被取消）</span>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'psc-contact-config',
    data() {
        return {
            loading: false,
            contactList: [],
            dialogMode: 'create',
            editForm: {
                id: '',
                country: '',
                phone: '',
                email: '',
                serviceTime: '',
                isDefault: false
            },
            delItemRow: null,
            delMsg: ''
        }
    },
    created() {
        this.loadList();
    },
    methods: {
        loadList() {
            this.loading = true
            this.api.pscContactList({}).then(res => {
                if (res.code === 200) {
                    this.contactList = res.data.list || []
                } else {
                    this.contactList = []
                }
                this.loading = false
            }).catch(() => {
                this.contactList = []
                this.loading = false
            })
        },
        resetForm() {
            this.editForm = {
                id: '',
                country: '',
                phone: '',
                email: '',
                serviceTime: '',
                isDefault: false
            }
        },
        openCreate() {
            this.dialogMode = 'create'
            this.resetForm()
            this.$refs.editDialog.show = true
        },
        openEdit(row) {
            this.dialogMode = 'edit'
            this.editForm = {
                id: row.id,
                country: row.country,
                phone: row.phone || '',
                email: row.email || '',
                serviceTime: row.service_time || '',
                isDefault: !!row.is_default
            }
            this.$refs.editDialog.show = true
        },
        confirmSubmit() {
            if (!this.editForm.country) {
                this.$message.warning('请输入国家/地区代码')
                return
            }
            if (this.dialogMode === 'create') {
                this.api.pscContactCreate({
                    country: this.editForm.country,
                    phone: this.editForm.phone,
                    email: this.editForm.email,
                    service_time: this.editForm.serviceTime,
                    is_default: this.editForm.isDefault
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('新增成功')
                        this.$refs.editDialog.show = false
                        this.loadList()
                    } else {
                        this.$message.error(res.msg || '新增失败')
                    }
                })
            } else {
                this.api.pscContactUpdate({
                    id: this.editForm.id,
                    phone: this.editForm.phone,
                    email: this.editForm.email,
                    service_time: this.editForm.serviceTime,
                    is_default: this.editForm.isDefault
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('更新成功')
                        this.$refs.editDialog.show = false
                        this.loadList()
                    } else {
                        this.$message.error(res.msg || '更新失败')
                    }
                })
            }
        },
        delItem(row) {
            this.delItemRow = row
            this.delMsg = '确认删除「' + row.country + '」的联系方式？'
            this.$refs.tip.show = true
        },
        delConfirm() {
            if (!this.delItemRow) {
                return
            }
            this.api.pscContactDelete({ id: this.delItemRow.id }).then(res => {
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.loadList()
                } else {
                    this.$message.error(res.msg || '删除失败')
                }
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .title_desc {
        margin-top: 8px;
        color: #999;
        font-size: 13px;
    }
    .btn_right_box {
        text-align: right;
    }
    .contact_grid {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        min-height: 120px;
        .contact_card {
            width: 320px;
            border: 1px solid #E8E9F1;
            border-radius: 10px;
            padding: 16px;
            background: #fff;
            .card_head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 12px;
                .country_name {
                    font-size: 16px;
                    font-weight: 700;
                    color: #333;
                }
                .default_tag {
                    background: #E1EAFF;
                    color: @colorBlue;
                    font-size: 12px;
                    padding: 2px 10px;
                    border-radius: 10px;
                }
            }
            .card_row {
                display: flex;
                font-size: 13px;
                line-height: 24px;
                label {
                    width: 60px;
                    color: #999;
                    flex-shrink: 0;
                }
                span {
                    color: #555;
                    word-break: break-all;
                }
            }
            .card_actions {
                display: flex;
                justify-content: flex-end;
                gap: 8px;
                margin-top: 10px;
                border-top: 1px solid #F2F3F8;
                padding-top: 10px;
            }
        }
        .empty_hint {
            width: 100%;
            text-align: center;
            color: #999;
            padding: 40px 0;
        }
    }
    .form_tip {
        color: #999;
        font-size: 12px;
        margin-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/contact-config.vue